import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default {
	init() {
		gsap.registerPlugin(ScrollTrigger);

		ScrollTrigger.create({
			trigger: '#projectsContent',
			start: 'top bottom',
			once: true,
			onEnter: () => {
				gsap.to('#projectsContent .project_thumb', { y: 0, duration: 0.5, delay: 0.5 });
			},
		});

		jQuery(document).ready(function ($) {
			var filterBtns = $('.js-filter-projects'),
				loadMoreBtn = $('#loadMoreBtn'),
				noPostsMsg = $('#noPostsMsg'),
				container = $('#at-project-gallery-container'),
				paged = 1,
				taxonomies = { project_category: [] };

			function loadProjects() {
				container.addClass('loading');
				noPostsMsg.hide();

				$.ajax({
					type: 'POST',
					url: '/wp-admin/admin-ajax.php',
					dataType: 'json',
					data: {
						action: 'projects_filter',
						taxonomies: taxonomies,
						paged: paged,
					},
					success: function (res) {
						if (res.posts) {
							if (paged === 1) {
								container.html(res.posts);
							} else {
								container.append(res.posts);
							}

							if (res.maxPages > paged) {
								loadMoreBtn.show();
							} else {
								loadMoreBtn.hide();
							}
						} else {
							container.html('');
							noPostsMsg.show();
							loadMoreBtn.hide();
						}

						container.removeClass('loading');
					},
					fail: function (err) {
						console.error('There was an error: ' + err);
						container.removeClass('loading');
					},
				});
			}

			filterBtns.on('click', function (e) {
				e.preventDefault();
				paged = 1;

				var $this = $(this),
					cat = $this.data('cat');

				$this.addClass('activeProjectFilter');
				filterBtns.not($this).removeClass('activeProjectFilter');

				taxonomies.project_category = cat === 'all' ? [] : [cat];

				loadProjects();
			});

			loadMoreBtn.on('click', function (e) {
				e.preventDefault();
				paged++;
				loadProjects();
			});
		});
	},
	finalize() {},
};
